import { Injectable } from '@angular/core';
import { CanMatch, Router, UrlTree } from '@angular/router';
import { AuthUtils } from 'app/core/auth/auth.utils';

/**
 * Deja entrar a la configuración de contratación (procedimientos, formularios, series,
 * plantillas, metadatos, áreas, procesos trabados) solo a superusuario.
 *
 * Es el mismo criterio que ya aplica el backend: todos los viewsets de `configuracion`
 * heredan de `AdminViewSet`, cuyo `IsAdminUser` valida `is_superuser`. El guard no agrega
 * seguridad —esa la pone el backend—, evita que a un usuario sin acceso le carguen 14
 * pantallas que solo le van a responder 403.
 */
@Injectable({ providedIn: 'root' })
export class ConfigAdminGuard implements CanMatch {
    constructor(private readonly _router: Router) {}

    canMatch(): boolean | UrlTree {
        const permissionsToken = localStorage.getItem('permissionsToken');
        if (!permissionsToken) {
            return this._router.parseUrl('/sign-in');
        }
        try {
            return AuthUtils._getTokenUser(permissionsToken)
                ? true
                : this._router.parseUrl('/home');
        } catch {
            return this._router.parseUrl('/home');
        }
    }
}
